module.exports = __webpack_public_path__ + "9eccd2951d8088a16e2873ba099f45b7.svg";